import React from 'react'
import CustomCursor from '../../Global/Cursor'
import Preloader from '../../Global/Preloader'
import Header from '../../Global/Header1'
import Pageheader from '../../Global/Pageheader'
import Details from '../MenDetails/Details'
import Cta from '../../Global/Cta'
import Footer from '../../Global/Footer1'
import GoToTop from '../../Global/GoToTop'

const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <Pageheader Title="Bank Credit Collection System" subtitle="Bank Credit Collection System" />
            <Details />
            <Cta />
            <Footer />
            <GoToTop />
        </>
    )
}

export default Main
